import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AuthenticationFacade } from '@planone/bau365/data-access-authentication';
import { DataAccessFairsFacade } from '@planone/bau365/data-access-fair-data';
import { loadContentSuccess, loadMoreContentSuccess } from '@planone/bau365/data-access-newsfeed';
import * as FeatureTrackingGoogleAnalytics from '@planone/shared/feature-tracking-google-analytics';
import * as FeatureTrackingSnowplow from '@planone/shared/feature-tracking-snowplow';
import { of, switchMap, withLatestFrom } from 'rxjs';

import { DataTransformationHelper } from '../../helper/data-transformation.helpers';
import { CustomEventIglu } from '../../tracking-types/snowplow/schema/schema.interface';

@Injectable()
export class NewsfeedEffects {
  loadMoreEntities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadMoreContentSuccess),
      withLatestFrom(this.fairsFacade.fairId$),
      switchMap(([_, fairId]) =>
        of(
          FeatureTrackingGoogleAnalytics.push({
            event: 'load_more_entities',
            page_type: 'newsfeed',
            context: fairId,
          })
        )
      )
    )
  );

  newsfeedImpressions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadContentSuccess, loadMoreContentSuccess),
      withLatestFrom(this.fairsFacade.fairId$, this.authenticationFacade.excludeAnalytics$),
      switchMap(([action, fairId, exclude_analytics]) =>
        of(
          FeatureTrackingSnowplow.selfDescribingEvent({
            event: {
              schema: CustomEventIglu.view_entity_impressions,
              data: {
                impressions: action.results.map(({ id, type }, index) => {
                  return { id, entity_type: type, position: index + action.count };
                }),
                context: fairId,
                page_type: 'newsfeed',
                exclude_analytics,
              },
            },
            context: <any>(
              action.results.map((entity) => this.dataTransformationHelper.snowplow?.map(entity.type, entity, fairId))
            ),
          })
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store,
    private fairsFacade: DataAccessFairsFacade,
    private authenticationFacade: AuthenticationFacade,
    private dataTransformationHelper: DataTransformationHelper
  ) {}
}
